import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../../components';
import { Typography, Stack, Button } from '@mui/material';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useRef } from 'react';

export const OPDTypeAmountForm = ({ onClose, onAdd, opdTypeDropdown = [] }) => {
  const opdTypeRef = useRef();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        opd_type: Yup.string().required(' '),
        amount: Yup.number().required(' '),
        discount: Yup.number().required(' ')
      })
    ),
    defaultValues: {
      discount: 0,
      amount: 0
    },
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmitHandler = (formValues) => {
    onAdd(formValues);
    reset();
    if (opdTypeRef.current) {
      opdTypeRef.current.focus();
    }
  };

  useEffect(() => {
    if (opdTypeRef.current) {
      opdTypeRef.current.focus();
    }
  }, []);
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
      <Stack sx={{ p: 1.5, minWidth: '35rem' }} spacing={2}>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2, fontWeight: 700 }}>OPD Type</Typography>
          <SelectTag
            formControlSX={{ flex: 0.8, border: '0.5px solid red', backgroundColor: '#B3E5FC' }}
            name="opd_type"
            menus={opdTypeDropdown.map((data) => ({ ...data, name: data.type }))}
            placeholder="Select OPD Type"
            inputRef={opdTypeRef}
          />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Discount</Typography>
          <TextField sx={{ flex: 0.8 }} name="discount" inputProps={{ min: 0 }} type="number" />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2 }}>Amount</Typography>
          <TextField
            sx={{ flex: 0.8, fontWeight: 700, border: '0.5px solid red', backgroundColor: '#B3E5FC' }}
            name="amount"
            inputProps={{ min: 0 }}
            type="number"
          />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2 }}>Other Charges</Typography>
          <TextField
            sx={{ flex: 0.8, fontWeight: 700, border: '0.5px solid red', backgroundColor: '#B3E5FC' }}
            name="other_charge"
            inputProps={{ min: 0 }}
            type="number"
          />
        </Stack>
        <Stack sx={{ flex: 1 }} spacing={0.5} direction="row" alignItems="center" justifyContent="end">
          <Button size="small" color="error" onClick={onClose}>
            Cancel
          </Button>
          <Button size="small" variant="contained" type="submit">
            Add
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  );
};
